import { c as _c } from "react/compiler-runtime";
/* eslint-disable tailwindcss/no-custom-classname */
import { MaterialIcon } from "@website/icons/material";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import LOGO from "@website/widget/banner/assets/logo.svg";
import styles from "@website/widget/banner/banner.module.scss";
import { BannerPropertiesType } from "@website/widget/banner/banner.types";
import { KeenSliderInstance } from "keen-slider";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import { FC, useRef } from "react";
const animation = {
  duration: 20_000,
  easing: (value: number) => value
};
export const Banner: FC<BannerPropertiesType> = t0 => {
  const $ = _c(20);
  const {
    link,
    icon,
    title,
    items
  } = t0;
  const itemsLength = items?.length ?? 0;
  const animatorReference = useRef(null as unknown as KeenSliderInstance<object, object>);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      spacing: 1,
      perView: "auto"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== itemsLength) {
    t2 = {
      loop: true,
      rtl: true,
      drag: true,
      mode: "free-snap",
      renderMode: "performance",
      slides: t1,
      created: slider => {
        animatorReference.current = slider;
        slider.moveToIdx(itemsLength, true, animation);
      },
      updated: slider_0 => {
        slider_0.moveToIdx(slider_0.track.details?.abs + itemsLength, true, animation);
      },
      animationEnded: slider_1 => {
        slider_1.moveToIdx(slider_1.track.details?.abs + itemsLength, true, animation);
      }
    };
    $[1] = itemsLength;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [sliderReference] = useKeenSlider(t2);
  let t3;
  if ($[3] !== items) {
    t3 = items?.map(_temp);
    $[3] = items;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== sliderReference || $[6] !== t3) {
    t4 = <div className={`keen-slider ${styles.slider}`} ref={sliderReference}>{t3}</div>;
    $[5] = sliderReference;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== icon) {
    t5 = <MaterialIcon className={styles.page_icon} name={icon} />;
    $[8] = icon;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== title) {
    t6 = <span className={`group-hover:block ${styles.page_title}`}>{title}</span>;
    $[10] = title;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <img alt="" className={styles.page_logo} src={LOGO.src} />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== link || $[14] !== t5 || $[15] !== t6) {
    t8 = <a className={`group ${styles.logo_wrapper}`} href={link} rel="nofollow noreferrer" target="_blank">{t5}{t6}{t7}</a>;
    $[13] = link;
    $[14] = t5;
    $[15] = t6;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t4 || $[18] !== t8) {
    t9 = <div className={styles.wrapper}>{t4}{t8}</div>;
    $[17] = t4;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
function _temp(t0, index) {
  const {
    currency,
    icon: icon_0,
    link: link_0,
    price,
    title: title_0
  } = t0;
  return <a className={`keen-slider__slide ${styles.item}`} href={link_0} key={`external-widget-banner-${index++}`} rel="nofollow noreferrer" target="_blank"><MaterialIcon className={styles.item_icon} name={icon_0} /><span className={styles.item_title}>{title_0}</span><span className={styles.item_price}>{numberConvert(numberSeparator(price), {
        locale: "fa"
      })}{" "}{currency}</span></a>;
}